import { Box, Grid, IconButton, Typography } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";

import TextField from "./TextField";

import { useRouteLoaderData } from "react-router-dom";
import { useOptimizationChangesDispatch } from "../OptimizationsContext";

const CreativeField = (creative) => {
  const dispatch = useOptimizationChangesDispatch();
  const creativeKind = Object.keys(creative)[0];
  const { user_agent: userAgentEnabled } =
    useRouteLoaderData("featureFlagLoader");
  if (creativeKind === "user_agent" && !userAgentEnabled) return;
  const updateOnPageLoadJs = (value) =>
    dispatch({
      action: "offer_attribute_changed",
      creative: { on_page_load_js: value },
    });

  const updateUserAgentOverride = (value) =>
    dispatch({
      action: "offer_attribute_changed",
      creative: { user_agent: value },
    });

  const listLabel =
    creativeKind === "on_page_load_js"
      ? "On Page Load JS"
      : "User Agent Override";

  return (
    <Grid
      container
      justifyContent="space-between"
      columnSpacing={2}
      direction="row"
      sx={{ mb: 2 }}
    >
      <Grid item xs={11}>
        <TextField
          size="small"
          label={listLabel}
          variant="standard"
          value={creative[creativeKind] || ""}
          multiline
          fullWidth
          onChange={(event) =>
            creativeKind === "on_page_load_js"
              ? updateOnPageLoadJs(event.target.value)
              : updateUserAgentOverride(event.target.value)
          }
        />
      </Grid>
      <Grid item xs={1}>
        <IconButton
          aria-label="delete"
          onClick={() =>
            creativeKind === "on_page_load_js"
              ? updateOnPageLoadJs(null)
              : updateUserAgentOverride(null)
          }
        >
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

const buildFormFields = (creatives) => {
  return ["on_page_load_js", "user_agent"]
    .filter((key) => creatives[key] != null)
    .map((key) => <CreativeField key={key} {...{ [key]: creatives[key] }} />);
};

const CreativeFormSection = (creatives) => {
  const { user_agent: userAgentEnabled } =
    useRouteLoaderData("featureFlagLoader");

  if (!("on_page_load_js" in creatives) && !userAgentEnabled) return;

  const formFields = buildFormFields(creatives);
  return (
    formFields.length > 0 && (
      <Box sx={{ mb: 1 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Creative
        </Typography>
        {formFields}
      </Box>
    )
  );
};

export default CreativeFormSection;
